import React from "react";
import cx from "ui/cx";
import IconCheck from "ui/icons/IconCheck";
import styles from "./OptionSelectCircle.module.scss";

interface OptionSelectCircleProps extends React.HTMLAttributes<HTMLElement> {
  selected: boolean;
  disabled?: boolean;
  highlighted?: boolean;
}

export default function OptionSelectCircle({ selected, disabled, highlighted, ...props }: OptionSelectCircleProps) {
  const classNames = cx({
    styles,
    wrapper: true,
    "circle-check": true,
    selected,
    disabled: disabled ?? false,
    highlighted: highlighted ?? false,
  });

  return (
    <div {...props} className={classNames}>
      {selected && <IconCheck data-title="selected" size={12} color="white" />}
    </div>
  );
}
